module.exports = __webpack_public_path__ + "media/St 4-desk lamp-question.f02f2670.wav";